import React, { useContext, useEffect } from "react";
import { DataContext } from "../context/DataContext";
import { useHistory } from "react-router-dom";
import { toTitleCase } from "../util/titleCase";
import BareboneModal from "../components/common/BareboneModal";
import Modal from "../components/common/Modal";
import classNames from "classnames";
import axios from "axios";
import Button from "../components/common/Button";
import BillsAccordionLayout from "./BillsAccordion";
import EmptyContent from "../components/common/EmptyContent";


const showModalStyling = classNames({
  "border-0 rounded-lg shadow-lg mx-auto w-10/12 sm:w-full p-5 sm:p-8 relative flex flex-col bg-white outline-none focus:outline-none": true,
});
const PaymentCard = ({ arrayDataSets }) => {
  const userDomainn = localStorage.getItem("schoolDomain");
  const allStudents = JSON.parse(localStorage.getItem('studentInfo'))
  const phoneNumber = allStudents[0].phonenumber
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [wardBillingList, setWardBillingList] = React.useState([]);
  const [isHovered, setIsHovered] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(0);

  const billingData = arrayDataSets;
  const dataContext = useContext(DataContext);
  const history = useHistory();

  useEffect(() => {

    if (billingData && Object.keys(billingData).length > 0) {

      const distinctBills = billingData?.bills.reduce((acc, bill) => {
        const { bill_name, term, session, bill_id, admissionnumber } = bill.fees;
        const exists = acc.some(
          (item) => item.bill_name === bill_name && item.term === term && item.session === session && item.admissionnumber === admissionnumber
        );
        if (!exists) {
          acc.push({ bill_name, term, session, bill_id, admissionnumber });
        }
        return acc;
      }, []);
      setWardBillingList(distinctBills)
    }

  }, [billingData]);

  const getMultiplePaymentsLink = async () => {
    const paymentIds = selectedItems.map((item) => item.fees.payment_id);

    try {
      setLoading(true);
      const { data } = await axios.get(
        `https://edves.cloud/api/v1/payments/test_multi/?student_payment_id=[${paymentIds}]`
      );
      console.log(data, "payment Id");
      if (data?.payment_link && data.payment_link.trim() !== "") {
        window.open(data.payment_link, "_blank");
        setLoading(false);
      } else {
        setLoading(false);
        // setErrorMessage(data?.detail);
      }
    } catch (error) {
      setLoading(false);
      // setFetchError(true);
    }
  };
  const sendClicked = (subject) => {
    // console.log(subject, "subjectsubjectsubjectsubject");
    localStorage.setItem("clickedHomework", JSON.stringify(subject));
    dataContext.setHomework(subject);
    history.push("/viewHomework");
  };
  const processAddOrRemove = (item) => {
    if (selectedItems.includes(item)) {
      setSelectedItems(
        selectedItems.filter((selectedItem) => selectedItem !== item)
      );
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const billsByAdmissionNumber = wardBillingList.reduce((acc, bill) => {
    if (!acc[bill?.admissionnumber.toLowerCase()]) {
      acc[bill?.admissionnumber.toLowerCase()] = [];
    }
    acc[bill?.admissionnumber.toLowerCase()].push(bill);
    return acc;
  }, {});

  console.log(allStudents[0]?.otherChild);
  // console.log({ arrayDataSets });

  return (
    <>
      {allStudents[0]?.otherChild.map((student, studentIndex) => {
        const studentBills = billsByAdmissionNumber[student.admissionnumber.toLowerCase()] || [];
        if (studentBills.length === 0) {
          return null; // Skip rendering if no bills found for the student
        }
        return (
          <BillsAccordionLayout
            key={studentIndex}
            title={`${student?.admissionnumber}`}
            name={`${student?.firstname} ${student?.surname}`}
            index={studentIndex + 1}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
          >

            {wardBillingList.length < 1 ?
              <div className='flex justify-center w-full sm:mt-16'>
                <EmptyContent message='No Bill Found' moreMessage='You can always check your child billings here' />
              </div>
              :
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 col-gap-6 px-4 mb-16">
                {
                  wardBillingList?.map((item, index2) => {
                    return (
                      <>
                        {item?.admissionnumber.toLowerCase() === student?.admissionnumber.toLowerCase() && <div
                          className="bg-white p-4 mb-6 text-gray-100 mr-4 newNotesShadow relative pt-8"
                          key={index2}
                          
                        >
                          <div className="flex justify-between items-center mb-4">


                            <div className="absolute flex justify-between items-center left-0 right-0 px-3">
                              <span
                                className={`rounded-full px-2 text-black text-12  ${item?.fees?.status.toLowerCase() === "unpaid"
                                  ? "bg-red-300"
                                  : item?.fees?.status.toLowerCase() === "overpaid"
                                    ? "bg-blue-100"
                                    : item?.fees?.status.toLowerCase() === "partly paid"
                                      ? "partlyPaidBG"
                                      : "bg-green-100"
                                  }`}
                              >
                                {item?.fees?.status}
                              </span>
                             
                            </div>
                          </div>
                          <div className="  ">

                            <div className="flex text-center justify-center w-full font-medium text-sm mb-2">
                              <div className="w-1/2">
                                <div className="text-12 text-gray-400 text-left">
                                  BILL NAME
                                </div>
                                <div className="text-left text-14">
                                  {toTitleCase(item?.bill_name)}{" "}
                                </div>
                              </div>
                              <div className="w-1/2">
                                <div className="text-xs text-gray-400 text-right">
                                  FEE TYPE
                                </div>
                                <div className="text-right">
                                  {item?.fees?.fee_type_name}
                                </div>
                              </div>
                            </div>

                            {/* <div className="flex text-center justify-center w-full font-medium text-sm mb-2">
                        <div className="w-1/2">
                          <div className="text-xs text-gray-400 text-left">
                            TOTAL AMOUNT
                          </div>
                          <div className="text-left">
                            N{item?.fees?.original_fee_amount}
                          </div>
                        </div>
                        <div className="w-1/2">
                          <div className="text-xs text-gray-400 text-right">
                            DISCOUNT
                          </div>
                          <div className="text-right">
                            N{item?.fees?.disctotal_discount_amountount}
                          </div>
                        </div>
                      </div> */}

                            <div className="flex text-center justify-center w-full font-medium text-sm mb-3">
                              <div className="w-1/2">
                                <div className="text-xs text-gray-400 text-left">
                                  TERM
                                </div>
                                <div className="text-left">
                                  {item?.term}
                                </div>
                              </div>
                              <div className="w-1/2">
                                <div className="text-xs text-gray-400 text-right">
                                  SESSION
                                </div>
                                <div className="text-right">
                                  {item?.session}
                                </div>
                              </div>
                            </div>

                            {/* <div className="flex text-center justify-center w-full font-medium text-sm mb-4">
                  <div className="w-1/2">
                    <div className="text-sm text-gray-300 text-left">
                      AMT: N{item?.fees?.fee_amount}
                    </div>
                  </div>
                  <div className="w-1/2">
                    <div className="text-sm text-gray-300 text-right">
                      DIS: {item?.fees?.total_discount_amount}
                    </div>
                  </div>
                  <br /> Fee Type: {item?.fees?.fee_type_name}
                  {toTitleCase(item.term)} <br /> {item.year}
                </div> */}

                            {/* <div className="flex text-center justify-center font-semibold  text-base ">
               code: {item.pickupCode}
              </div> */}
                            {selectedItems?.length < 2 && (
                              <>
                                {item?.fees?.status.toLowerCase() === "fully paid" ? <div className="bg-blue-900 block mx-auto">

                                  <a
                                    rel="noopener noreferrer"
                                    className="flex justify-center text-blue-100 text-xs font-semibold leading-3 p-2 cursor-pointer"
                                  >
                                    Fully Paid
                                  </a>
                                </div> : <div className="bg-blue-900 block mx-auto">

                                  <a
                                    href={`http://demo.edves.net/pay2/billing?bill=${item?.bill_id}&phone=07032089754&adm=Chisom/11&ses=${item?.session}&term=${item?.term}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex justify-center text-blue-100 text-xs font-semibold leading-3 p-2 cursor-pointer"
                                  >
                                    Make Payment
                                  </a>
                                </div>}
                              </>

                            )}
                          </div>
                        </div>}

                      </>
                    )
                  })
                }
              </div>
            }
          </BillsAccordionLayout>
        );
      })}



    </>
  );
};

export default PaymentCard;
